<template>
<div id="satisfaction-client-global" class="data-list-container">

    <vs-row>
        <vs-col vs-w="12">
            <div class="vx-card">
                <div class="vx-card__header">
                    <div class="vx-card__title">
                        <h4 class>Variation de lévaluation positive les vingt dernier jours</h4>
                    </div>
                </div>
                <div class="vx-card__body">
                    <vue-apex-charts :key="dataupdateKey" type="line" height="350" :options="lineChartSimple1.chartOptions" :series="lineChartSimple1.series"></vue-apex-charts>
                </div>
            </div>
        </vs-col>
    </vs-row>

    <vs-row style="margin-top:10px">
        <vs-col vs-w="12">
            <div class="vx-card">
                <div class="vx-card__header">
                    <div class="vx-card__title">
                        <h4 class>Variation de lévaluation négative les vingt dernier jours</h4>
                    </div>
                </div>
                <div class="vx-card__body">
                    <vue-apex-charts :key="dataupdateKey" type="line" height="350" :options="lineChartSimple2.chartOptions" :series="lineChartSimple2.series"></vue-apex-charts>
                </div>
            </div>
        </vs-col>
    </vs-row>

    <vs-row style="margin-top:10px">
        <vs-col vs-w="12">
            <div class="vx-card">
                <div class="vx-card__header">
                    <div class="vx-card__title">
                        <h4 class>Variation de satisfaction les vingt dernier jours</h4>
                    </div>
                </div>
                <div class="vx-card__body">
                    <vue-apex-charts :key="dataupdateKey" type="area" height="350" :options="lineAreaChartSpline.chartOptions" :series="lineAreaChartSpline.series"></vue-apex-charts>
                </div>
            </div>
        </vs-col>
    </vs-row>

    <vs-row style="margin-top:10px">
        <vs-col vs-w="12">
            <div class="vx-card">
                <div class="vx-card__header">
                    <div class="vx-card__title">
                        <h4 class>Evaluations des clients les vingt dernier jours</h4>
                    </div>
                </div>
                <div class="vx-card__body">
                    <vue-apex-charts :key="dataupdateKey" type="bar" height="350" :options="columnChart.chartOptions" :series="columnChart.series"></vue-apex-charts>
                </div>
            </div>
        </vs-col>
    </vs-row>

    <vs-row style="margin-top:10px">
        <vs-col style="padding-right:5px" vs-w="6">
            <div class="vx-card">
                <div class="vx-card__header">
                    <div class="vx-card__title">
                        <h4 class>Top 10 client satisfait dernier mois</h4>
                    </div>
                </div>
                <div class="vx-card__body">
                    <vue-apex-charts :key="dataupdateKey" type="bar" height="350" :options="barChart.chartOptions" :series="barChart.series"></vue-apex-charts>
                </div>
            </div>
        </vs-col>

        <vs-col style="padding-left:5px" vs-w="6">
            <div class="vx-card">
                <div class="vx-card__header">
                    <div class="vx-card__title">
                        <h4 class>Top 10 client non satisfait dernier mois</h4>
                    </div>
                </div>
                <div class="vx-card__body">
                    <vue-apex-charts :key="dataupdateKey" type="bar" height="350" :options="barChart1.chartOptions" :series="barChart1.series"></vue-apex-charts>
                </div>
            </div>
        </vs-col>
    </vs-row>

</div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import indexEvaluation from "@/http/requests/evaluation/index.js";

export default {
    components: {
        VueApexCharts,
    },
    data() {
        return {
            lineAreaChartSpline: {
                series: [{
                    name: 'satisfait',
                    data: []
                }, {
                    name: 'non satisfait',
                    data: []
                }],
                chartOptions: {
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    colors: ['#28C76F', '#EA5455'],
                    xaxis: {
                        type: 'datetime',
                        categories: [],
                    },
                    tooltip: {
                        x: {
                            format: 'dd/MM/yy HH:mm'
                        },

                    }
                }
            },
            barChart: {
                series: [{
                    name: 'Client satisfait',
                    data: []
                }],
                chartOptions: {
                    colors: ['#7367F0'],
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    xaxis: {
                        categories: [],
                    }
                }
            },
            barChart1: {
                series: [{
                    name: 'Client non satisfait',
                    data: []
                }],
                chartOptions: {
                    colors: ['#7367F0'],
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    xaxis: {
                        categories: [],
                    }
                }
            },
            columnChart: {
                series: [{
                    name: 'Client Satisfait',
                    data: []
                }, {
                    name: 'Client Neutre',
                    data: []
                }, {
                    name: 'Client Non Satisfait',
                    data: []
                }],
                chartOptions: {
                    colors: ['#28C76F', '#FF9F43', '#EA5455'],
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            endingShape: 'rounded',
                            columnWidth: '55%',
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },

                    xaxis: {
                        categories: [],
                    },
                    fill: {
                        opacity: 1

                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return +val
                            }
                        }
                    }
                }
            },
            dataupdateKey: 0,
            lineChartSimple1: {
                series: [{
                    name: "Satisfait",
                    data: []
                }],
                chartOptions: {
                    chart: {
                        height: 350,
                        zoom: {
                            enabled: false
                        }
                    },
                    colors: ['#28C76F'],
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    grid: {
                        row: {
                            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                            opacity: 0.5
                        },
                    },
                    xaxis: {
                        categories: [],
                    }
                }
            },
            lineChartSimple2: {
                series: [{
                    name: "Non satisfait",
                    data: []
                }],
                chartOptions: {
                    chart: {
                        height: 350,
                        zoom: {
                            enabled: false
                        }
                    },
                    colors: ['#EA5455'],
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    grid: {
                        row: {
                            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                            opacity: 0.5
                        },
                    },
                    xaxis: {
                        categories: [],
                    }
                }
            }
        };
    },
    watch: {},
    computed: {},
    methods: {
        Last10Days() {
            return '0123456789'.split('').map(function (n) {
                var d = new Date();
                d.setDate(d.getDate() - n);
                return (function (day, month, year) {
                    return [day < 10 ? '0' + day : day, month < 10 ? '0' + month : month, year].join('/');
                })(d.getDate(), d.getMonth());
            }).join(',');
        },
        loadData() {
            try {
                indexEvaluation.getStat().then(response => {
                    let categories = [];
                    let data1 = [];
                    let data2 = [];
                    let data3 = [];
                    let categories1 = [];
                    let data4 = [];
                    let categories2 = [];
                    let data5 = [];
                    let lineAreaChartSplineCategories = [];
                    let lineAreaChartSplineData1 = [];
                    let lineAreaChartSplineData2 = [];
                    response.data.variation.forEach(element => {
                        categories.push(element[0])
                        data1.push(element[1])
                        data2.push(element[2])
                        data3.push(element[3])
                        lineAreaChartSplineCategories.push(element[4])
                        lineAreaChartSplineData1.push(element[1])
                        lineAreaChartSplineData2.push(element[2])
                    });
                    response.data.top10Happy.forEach(element => {
                        categories1.push(element[0])
                        data4.push(element[1])
                    });
                    response.data.top10Sad.forEach(element => {
                        categories2.push(element[0])
                        data5.push(element[1])
                    });
                    this.lineChartSimple1.chartOptions.xaxis.categories = categories;
                    this.lineChartSimple1.series[0].data = data1
                    this.lineChartSimple2.chartOptions.xaxis.categories = categories;
                    this.lineChartSimple2.series[0].data = data2
                    this.columnChart.chartOptions.xaxis.categories = categories;
                    this.columnChart.series[0].data = data1
                    this.columnChart.series[1].data = data3
                    this.columnChart.series[2].data = data2
                    this.barChart.chartOptions.xaxis.categories = categories1;
                    this.barChart.series[0].data = data4
                    this.barChart1.chartOptions.xaxis.categories = categories2;
                    this.barChart1.series[0].data = data5
                    this.lineAreaChartSpline.chartOptions.xaxis.categories = lineAreaChartSplineCategories;
                    this.lineAreaChartSpline.series[0].data = lineAreaChartSplineData1
                    this.lineAreaChartSpline.series[1].data = lineAreaChartSplineData2
                    this.dataupdateKey += 1;
                })
                this.$vs.loading.close("#satisfaction-client > .con-vs-loading");
            } catch {
                this.$vs.loading.close();
                this.$vs.notify({
                    time: 10000,
                    title: "Erreur s'est produite l'ors de la récupération de données",
                    text: "Erreur",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circles"
                });
            }
        }
    },

    created() {
        if (this.$store.state.AppActiveUser.id != '') {
            this.loadData();
        } else {
            this.$store.subscribe(mutation => {
                if (mutation.type === "UPDATE_USER_INFO") {
                    this.loadData();
                }
            });
        }
    },
    mounted() {}
};
</script>

<style >

</style>
